module.exports = __webpack_public_path__ + "static/media/7 Secret CCTV Business - with Cover.087ae7bc.pdf";